import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=63530f9a"
import script from "./Score.vue?vue&type=script&lang=ts"
export * from "./Score.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports